/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GradeSimulationDisciplineViewModel } from "../types/GradeSimulationDisciplineViewModel.ts";

export const gradeSimulationDisciplineViewModelSchema = z.object({
  classModuleId: z.optional(z.number().int()),
  moduleName: z.string().nullish(),
  disciplineId: z.optional(z.number().int()),
  disciplineName: z.string().nullish(),
  classesCount: z.optional(z.number().int()),
  workloadHours: z.optional(z.number()),
  grade: z.number().nullish(),
  frequency: z.number().nullish(),
  isIncludedInGradeCalculation: z.optional(z.boolean()),
  isIncludedInAttendanceCalculation: z.optional(z.boolean()),
}) as unknown as ToZod<GradeSimulationDisciplineViewModel>;
